module.exports = __webpack_public_path__ + "img/catch-plan-bg.9255ad4b.jpg";